<template>
    <div v-show="!isLoading">
        <Header page-type="top">
            <template v-slot:menu_left>
                <img src="../assets/img/logo.png" class="logo" alt="HACCP STATION">
            </template>
            <template v-slot:menu_right>
                <a href="#" role="button" @click.prevent.stop="openAlertModal()" ><img src="../assets/img/inc_alert_off.png"></a>
            </template>
        </Header>

        <div class="main_unit">
            <div class="top_unit">
                <div class="top_name_box">{{brandName}}</div>
                <div class="top_right_box_mgt">プレビュー表示 </div>
            </div>
            <div class="menu_top_unit">
                <p class="menu_staff_tit"></p>
                <div class="menu_staff_box">
                    <ul>
                        <li v-for="(menu, index) in staffMenu" :key="menu.id" :class="classList['li'][index]">
                            <a href="#" v-show="menu.displayFlg" :class="classList['a'][menu.index-1]" role="button" @click.prevent.stop="openAlertModal()">
                                <p class="menu_staff_tit_s" :id="menu.index">{{menu.upperButtonName}}</p>{{menu.lowerButtonName}}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="menu_top_unit">
                <p class="menu_kanri_tit"></p>
                <div class="menu_kanri_box">
                    <ul>
                        <li v-for="menu in managerMenu" :key="menu.id" >
                            <a href="#" role="button" @click.prevent.stop="openAlertModal()">{{menu.title}}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <AlertDialog :display="showModal.alertDisplay" @close="closeAlertModal"/>

    </div>
</template>

<script>
    // @ is an alias to /src
    import Header from '@/app/components/Header.vue'
    import AlertDialog from '@/app/components/common/AlertDialog.vue'

    export default {
        name: "TopPreview",
        components: {
            //警告ダイアログは共通化する
            Header,
            AlertDialog
        },
        props: {
        },
        computed: {
            topButtonId: function () {
                return Number(this.$store.getters['checkPage/id']);
            },
            topButtonNo: function () {
                return Number(this.$store.getters['checkPage/buttonNo']);
            },
            upperButtonName: function () {
                return this.$store.getters['preview/upperButtonName'];
            },
            lowerButtonName: function () {
                return this.$store.getters['preview/lowerButtonName'];
            },
            displayFlg: function () {
                return Number(this.$store.getters['preview/displayFlg']);
            },
            brandId: function () {
                return this.$store.getters['brand/id']
            },
            brandName: function () {

                let brandName = this.$store.getters['brand/name'];

                if (brandName == null) {
                    brandName = ''
                }

                return brandName;
            },
            classList: function () {
                let list = {
                    li: [
                        'staff_4side',
                        '',
                        'staff_4side',
                        'staff_4center',
                    ],
                    a: [
                        'top_bg01',
                        'top_bg02',
                        'top_bg03',
                        'top_bg04',
                    ]
                }
                if (this.staffMenu.length < 3) {
                    list.li = [
                        '',
                        '',
                        '',
                        ''
                    ]
                }
                return list
            }
        },
        data() {
            return {
                isLoading:true,
                showModal: {
                    alertDisplay:false
                },
                staffMenu: null,
                managerMenu: [
                    {id: 1, title: "衛生管理計画書"},
                    {id: 2, title: "報告書一覧"},
                    {id: 3, title: "温度・湿度管理一覧"},
                    {id: 4, title: "設定メニュー"},
                ]
            }
        },
        created: function() {
            this.init()
        },
        methods: {
            init: function () {
                //メニュー情報の取得処理の呼び出し
                this.fetchTopButtonList();
            },
            fetchTopButtonList () {
                var datetime = this.dateFormat();

                // APIパス
                const url = this.$apiEndpoint + 'user/' + this.brandId + '/top?datetime=' + datetime
                // API呼び出し
                this.$axios.get(url).then(response => {
                    let menu = response['data']['menu']

                    menu = this.replaceTopButtonList(menu);

                    // CSSに合わせて並び替え
                    let list = menu.map(x => {
                        let button = x
                        let buttonIndex = x.no

                        if (x.no === 2) {
                            buttonIndex = 3
                        } else if (x.no === 3) {
                            buttonIndex = 2
                        }
                        button.index = buttonIndex

                        return button
                    })

                    list.sort((a, b) => a.index - b.index)

                    this.staffMenu = list

                }).catch((err) => {
                    let error = {
                        button: {
                            path: {name: ''}
                        },
                        canBack: false
                    }
                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(() => this.isLoading = false);
            },
            replaceTopButtonList (list) {
                //レスポンスに存在するか
                let index = list.findIndex((v) => v.id === this.topButtonId);
                if(!this.displayFlg) {
                    //displayFlgが0
                    if(index > -1) {
                        // 配列に存在すれば削除
                        list.splice(index, 1);
                    }
                } else {
                    //displayFlgが1
                    let button = {
                        id: this.topButtonId,
                        index: this.topButtonNo,
                        no: this.topButtonNo,
                        upperButtonName: this.upperButtonName,
                        lowerButtonName: this.lowerButtonName,
                        displayFlg: this.displayFlg
                    };

                    let deleteCount = 0;
                    if(index > -1) {
                        // 配列に存在すれば置き換える
                        deleteCount = 1;
                    }

                    list.splice(index, deleteCount, button);
                }

                return list;
            },
            openAlertModal() {
                this.showModal.alertDisplay = true;
            },
            closeAlertModal() {
                this.showModal.alertDisplay = false;
            },
            dateFormat(){
                let nowDate = new Date();
                nowDate.setDate(nowDate.getDate() + 1);
                let year = nowDate.getFullYear();
                let month = ("0" + (nowDate.getMonth()+1)).slice(-2);
                let day = ("0" + nowDate.getDate()).slice(-2);
                let hours = ("0" + nowDate.getHours()).slice(-2);
                let minutes = ("0" + nowDate.getMinutes()).slice(-2);
                let seconds = ("0" + nowDate.getSeconds()).slice(-2);

                let format_str = 'YYYYMMDDhhmmss'
                format_str = format_str.replace(/YYYY/g,year);
                format_str = format_str.replace(/MM/g,month);
                format_str = format_str.replace(/DD/g,day);
                format_str = format_str.replace(/hh/g,hours);
                format_str = format_str.replace(/mm/g,minutes);
                format_str = format_str.replace(/ss/g,seconds);
                return format_str;
            }
        }
    }
</script>